import React, { Component } from 'react';

import '../css/OpenSlideShow.css';

class OpenSlideShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_lang: this.props.lang,
      animationComplete: false,
      slideContent: {
        "zh": "Nexuni 耐思尼致力於推動 AI 機器人的落地，解決產業缺工問題。",
        "en": "We develop AI-powered robots designed for real-world deployment, focusing on solving industrial labor shortages through physical AI.",
        "ja": "NexuniはAIロボット技術の導入を推進し、産業界の労働力不足を解決することに取り組んでいます。"
      },
      valueProp: {
        "zh": "AI Robots, Ready to Work.",
        "en": "AI Robots, Ready to Work.",
        "ja": "AI Robots, Ready to Work."
      },
      ctaText: {
        "zh": "探索產品",
        "en": "Explore Products",
        "ja": "製品を見る"
      },
    }
  }

  componentDidMount() {
    this.animTimer = setTimeout(() => {
      this.setState({ animationComplete: true });
    }, 5500);
  }

  componentWillUnmount() {
    if (this.animTimer) clearTimeout(this.animTimer);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.current_lang) {
      this.setState({ current_lang: nextProps.lang });
    }
  }

  render() {
    const lang = this.state.current_lang;
    const letters = [
      { id: 'n1', src: '/assets/mainpage_nexuni_n.svg', alt: 'N', startX: -35, startY: -30 },
      { id: 'e',  src: '/assets/mainpage_nexuni_e.svg', alt: 'E', startX: 25,  startY: -35 },
      { id: 'x',  src: '/assets/mainpage_nexuni_x.svg', alt: 'X', startX: -20, startY: 40 },
      { id: 'u',  src: '/assets/mainpage_nexuni_u.svg', alt: 'U', startX: 30,  startY: 35 },
      { id: 'n2', src: '/assets/mainpage_nexuni_n.svg', alt: 'N', startX: -40, startY: 15 },
      { id: 'i',  src: '/assets/mainpage_nexuni_i.svg', alt: 'I', startX: 38,  startY: -20 },
    ];

    return (
      <div className="hero-section">
        {/* Background video — fades in behind the persisting logo */}
        <div className="hero-video-bg" style={{ animation: 'fade-in 1.5s ease 3.5s forwards' }}>
          <video autoPlay muted loop playsInline>
            <source src="/video/main_video.mp4" type="video/mp4" />
          </video>
          <div className="hero-video-overlay"></div>
        </div>

        {/* Grid pattern overlay */}
        <div className="hero-grid-pattern"></div>

        {/* X split animation */}
        <div className="hero-x-split">
          <img
            className="hero-x-left"
            src="/assets/mainpage_nexuni_opening_l.svg"
            alt="X-left"
            style={{ animation: 'move-right 1.5s ease 0s forwards, fade-out 1.5s ease 0.75s forwards' }}
          />
          <img
            className="hero-x-right"
            src="/assets/mainpage_nexuni_opening_r.svg"
            alt="X-right"
            style={{ animation: 'move-left 1.5s ease 0s forwards, fade-out 1.5s ease 0.75s forwards' }}
          />
        </div>

        {/* Logo group — stays visible, shifts up when content appears */}
        <div className="hero-logo-group" style={{ animation: 'logo-settle 1s ease 3.5s forwards' }}>
          <div className="hero-letters">
            {letters.map((letter) => (
              <div
                className={"hero-letter-container" + (letter.id === 'i' ? " hero-letter-i" : "")}
                key={letter.id}
                style={{
                  '--start-x': letter.startX + 'vw',
                  '--start-y': letter.startY + 'vh',
                }}
              >
                <img
                  className="hero-letter-svg"
                  src={letter.src}
                  alt={letter.alt}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Content revealed below the logo */}
        <div className="hero-content" style={{ animation: 'hero-content-in 1.2s ease 4.0s forwards' }}>
          <h1 className="hero-value-prop">{this.state.valueProp[lang]}</h1>
          <p className="hero-sub-text">{this.state.slideContent[lang]}</p>
          <button className="hero-cta" onClick={() => this.props.navigate('/solutions')}>
            {this.state.ctaText[lang]}
          </button>
        </div>

        {/* Scroll indicator */}
        {this.state.animationComplete && (
          <div className="hero-scroll-indicator">
            <div className="hero-scroll-line"></div>
          </div>
        )}
      </div>
    );
  }
}

export default OpenSlideShow;
